// extracted by mini-css-extract-plugin
export var catalogHeader = "style-module--catalogHeader--ba40d";
export var details = "style-module--details--9d6d0";
export var inner = "style-module--inner--8c67c";
export var productHeader = "style-module--productHeader--940b9";
export var sku = "style-module--sku--98cdb";
export var title = "style-module--title--b8825";